import { Routes } from '@angular/router';

/**
 * Child routes for the customer onboarding flow (lazy page components).
 */
export const CUSTOMER_ONBOARDING_CHILD_ROUTES: Routes = [
  { path: '', redirectTo: 'customer-profile/basic-information', pathMatch: 'full' },
  {
    path: 'customer-profile',
    children: [
      { path: '', redirectTo: 'basic-information', pathMatch: 'full' },
      {
        path: 'basic-information',
        loadComponent: () =>
          import('./pages/customer-profile/basic-information/component/customer-profile-basic-information.component').then(
            (m) => m.CustomerProfileBasicInformationComponent,
          ),
      },
      {
        path: 'service-options',
        loadComponent: () =>
          import('./pages/customer-profile/service-options/component/customer-profile-service-options.component').then(
            (m) => m.CustomerProfileServiceOptionsComponent,
          ),
      },
      {
        path: 'equipment-needs',
        loadComponent: () =>
          import('./pages/customer-profile/equipment-needs/component/customer-profile-equipment-needs.component').then(
            (m) => m.CustomerProfileEquipmentNeedsComponent,
          ),
      },
    ],
  },
  {
    path: 'operational-rules',
    children: [
      { path: '', redirectTo: 'drive-vs-fly', pathMatch: 'full' },
      {
        path: 'drive-vs-fly',
        loadComponent: () =>
          import('./pages/operational-rules/drive-vs-fly/component/operational-rules-drive-vs-fly.component').then(
            (m) => m.OperationalRulesDriveVsFlyComponent,
          ),
      },
      {
        path: 'code-3-lights-sirens',
        loadComponent: () =>
          import('./pages/operational-rules/code-3-lights-sirens/component/operational-rules-code-3-lights-sirens.component').then(
            (m) => m.OperationalRulesCode3LightsSirensComponent,
          ),
      },
      {
        path: 'aircraft-types',
        loadComponent: () =>
          import('./pages/operational-rules/aircraft-types/component/operational-rules-aircraft-types.component').then(
            (m) => m.OperationalRulesAircraftTypesComponent,
          ),
      },
      {
        path: 'ground-vehicles',
        loadComponent: () =>
          import('./pages/operational-rules/ground-vehicles/component/operational-rules-ground-vehicles.component').then(
            (m) => m.OperationalRulesGroundVehiclesComponent,
          ),
      },
      {
        path: 'hot-standby',
        loadComponent: () =>
          import('./pages/operational-rules/hot-standby/component/operational-rules-hot-standby.component').then(
            (m) => m.OperationalRulesHotStandbyComponent,
          ),
      },
      {
        path: 'ground-transit-rules',
        loadComponent: () =>
          import('./pages/operational-rules/ground-transit-rules/component/operational-rules-ground-transit-rules.component').then(
            (m) => m.OperationalRulesGroundTransitRulesComponent,
          ),
      },
      {
        path: 'opo-pickups',
        loadComponent: () =>
          import('./pages/operational-rules/opo-pickups/component/operational-rules-opo-pickups.component').then(
            (m) => m.OperationalRulesOpoPickupsComponent,
          ),
      },
      {
        path: 'vendors',
        loadComponent: () =>
          import('./pages/operational-rules/vendors/component/operational-rules-vendors.component').then(
            (m) => m.OperationalRulesVendorsComponent,
          ),
      },
    ],
  },
  {
    path: 'financial',
    children: [
      { path: '', redirectTo: 'catering', pathMatch: 'full' },
      {
        path: 'catering',
        loadComponent: () =>
          import('./pages/financial/catering/component/financial-catering.component').then((m) => m.FinancialCateringComponent),
      },
      {
        path: 'cancellation-fees',
        loadComponent: () =>
          import('./pages/financial/cancellation-fees/component/financial-cancellation-fees.component').then(
            (m) => m.FinancialCancellationFeesComponent,
          ),
      },
      {
        path: 'invoice-configuration',
        loadComponent: () =>
          import('./pages/financial/invoice-configuration/component/financial-invoice-configuration.component').then(
            (m) => m.FinancialInvoiceConfigurationComponent,
          ),
      },
    ],
  },
  {
    path: 'contact-escalation',
    children: [
      { path: '', redirectTo: 'point-of-contact', pathMatch: 'full' },
      {
        path: 'point-of-contact',
        loadComponent: () =>
          import('./pages/contact-escalation/point-of-contact/component/contact-escalation-point-of-contact.component').then(
            (m) => m.ContactEscalationPointOfContactComponent,
          ),
      },
      {
        path: 'aoc-escalation-group',
        loadComponent: () =>
          import('./pages/contact-escalation/aoc-escalation-group/component/contact-escalation-aoc-escalation-group.component').then(
            (m) => m.ContactEscalationAocEscalationGroupComponent,
          ),
      },
      {
        path: 'do-not-assign',
        loadComponent: () =>
          import('./pages/contact-escalation/do-not-assign/component/contact-escalation-do-not-assign.component').then(
            (m) => m.ContactEscalationDoNotAssignComponent,
          ),
      },
    ],
  },
  {
    path: 'communications',
    children: [
      { path: '', redirectTo: 'channels-notifications', pathMatch: 'full' },
      {
        path: 'channels-notifications',
        loadComponent: () =>
          import('./pages/communications/channels-notifications/component/communications-channels-notifications.component').then(
            (m) => m.CommunicationsChannelsNotificationsComponent,
          ),
      },
      {
        path: 'chain-of-custody',
        loadComponent: () =>
          import('./pages/communications/chain-of-custody/component/communications-chain-of-custody.component').then(
            (m) => m.CommunicationsChainOfCustodyComponent,
          ),
      },
      {
        path: 'itinerary-delivery',
        loadComponent: () =>
          import('./pages/communications/itinerary-delivery/component/communications-itinerary-delivery.component').then(
            (m) => m.CommunicationsItineraryDeliveryComponent,
          ),
      },
      {
        path: 'trip-surveys-recaps',
        loadComponent: () =>
          import('./pages/communications/trip-surveys-recaps/component/communications-trip-surveys-recaps.component').then(
            (m) => m.CommunicationsTripSurveysRecapsComponent,
          ),
      },
    ],
  },
  {
    path: 'locations-labs',
    children: [
      { path: '', redirectTo: 'preferred-locations', pathMatch: 'full' },
      {
        path: 'preferred-locations',
        loadComponent: () =>
          import('./pages/locations-labs/preferred-locations/component/locations-labs-preferred-locations.component').then(
            (m) => m.LocationsLabsPreferredLocationsComponent,
          ),
      },
      {
        path: 'labs',
        loadComponent: () =>
          import('./pages/locations-labs/labs/component/locations-labs-labs.component').then((m) => m.LocationsLabsLabsComponent),
      },
    ],
  },
  {
    path: 'system-features',
    children: [
      { path: '', redirectTo: 'bulletins', pathMatch: 'full' },
      {
        path: 'bulletins',
        loadComponent: () =>
          import('./pages/system-features/bulletins/component/system-features-bulletins.component').then(
            (m) => m.SystemFeaturesBulletinsComponent,
          ),
      },
      {
        path: 'response-area-map',
        loadComponent: () =>
          import('./pages/system-features/response-area-map/component/system-features-response-area-map.component').then(
            (m) => m.SystemFeaturesResponseAreaMapComponent,
          ),
      },
    ],
  },
  {
    path: 'review-submit',
    loadComponent: () => import('./pages/review-submit/component/review-submit.component').then((m) => m.ReviewSubmitComponent),
  },
];
